import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { TextInput } from "./";
import { EN, FR } from "../enums/languages";
import { MAX_DECIMAL } from "../Configurations/DecimalConfiguration";

class CurrencyInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = { showMask: true };

    this.format = this.format.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.getMaskValue = this.getMaskValue.bind(this);
    this.onChange = this.onChange.bind(this);
    this.normalizeValue = this.normalizeValue.bind(this);
  }

  normalizeValue(value) {
    if (value == null || value === "") return "";
    const str = value.toString();
    const num = Number(str);
    if (num === 0) return "0";
    return str;
  }

  format(value) {
    if (value == null || value === "") return "";

    const num = parseFloat(value.toString().replace(",", "."));
    if (isNaN(num)) return value;

    const strValue = value.toString();
    const decimalPart = strValue.split(/[.,]/)[1] || "";
    const numDecimals = decimalPart.length;
    if (numDecimals > MAX_DECIMAL) {
      // Does not automatically round off the value 
      return strValue;
    }

    return num.toLocaleString(this.props.languageCode, {
      style: "currency",
      currency: "CAD",
      currencyDisplay: "symbol",
      minimumFractionDigits: 0,
    });
  }



  onChange(e) {
    const value = e.target.value;

    if (/^[0-9]*[.,]?[0-9]*$/.test(value) || value === "") {
      this.props.input && this.props.input.onChange(value);
    }
  }

  onBlur() {
    this.setState({ showMask: true });
    const input = this.props.input;
    if (input && input.value != null && input.value !== "") {
      input.onChange(input.value.toString().replace(",", "."));
    }
  }

  onFocus() {
    this.setState({ showMask: false });
    const input = this.props.input;
    if (input && input.value != null) {
      input.onChange(this.normalizeValue(input.value));
    }
  }

  getMaskValue() {
    const { showMask } = this.state;
    const input = this.props.input || {};
    if (!showMask || !input.value) return false;

    const normalized = this.normalizeValue(input.value);
    return this.format(normalized);
  }

  componentDidMount() {
    const input = this.props.input;
    if (input && input.value != null) {
      input.onChange(this.normalizeValue(input.value));
    }
  }
  componentDidUpdate(prevProps) {
    const input = this.props.input;
    if (input && input.value != null && prevProps.input.value != input.value) {
      input.onChange(this.normalizeValue(input.value));
    }
  }

  render() {
    const { languageCode, type = "absNumber", dispatch, ...props } = this.props;
    const inputProps = this.props.input || {};
    const formatOverlay = this.getMaskValue();

    return (
      <TextInput
        {...props}
        {...inputProps}
        type={type}
        value={inputProps.value || ""}
        onChange={this.onChange}
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        formatOverlay={formatOverlay}
      />
    );
  }
}

CurrencyInput.propTypes = {
  dispatch: PropTypes.func,
  input: PropTypes.object,
  languageCode: PropTypes.oneOf([EN.value, FR.value]),
  type: PropTypes.string,
};

CurrencyInput.defaultProps = {
  languageCode: EN.value,
  type: "absNumber",
};

const mapStateToProps = (state) => ({
  languageCode: state.auth.user.languageCode,
});

export default connect(mapStateToProps)(CurrencyInput);



// WEBPACK FOOTER //
// ./src/components/common/form/CurrencyInput.js